export const JIRA_IMPORT_DETAILS_MODAL_ID = 'jira-import-details';
